import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import setActiveBrand from '../../redux/actions/carBrand';
import setSearchCars from '../../redux/actions/searchCars';
import sortCarsArray from '../../redux/actions/catalogSort';
import setShowCars from '../../redux/actions/carCard';
import setActivePage from '../../redux/actions/pagination';
import setPrice from '../../redux/actions/price';
import { DELAY, MIN_PRICE, MAX_PRICE } from '../../constants';
import { scrollPageToTop } from '../../utilites';

export default () => {
  const { cars, carBrands } = startup;
  const orderedBy = useSelector((state) => state.catalog.orderedBy);
  const dispatch = useDispatch();
  const carCountInEachBrand = [];
  let allCarsCount = cars.length;
  const carBrandsNames = Object.keys(carBrands);
  for (let i = 0; i < carBrandsNames.length; i += 1) {
    if (allCarsCount < 1) break;
    const carsInBrand = cars.filter((el) => el.Car.Brand === carBrandsNames[i]);
    carCountInEachBrand.push([carBrandsNames[i], carsInBrand.length]);
    allCarsCount -= carsInBrand.length;
  }
  const setBrand = (brand) => {
    dispatch(setActiveBrand(brand));
    dispatch(setPrice([MIN_PRICE, MAX_PRICE]));
    const data = new Map();
    data.set('Brand', brand);
    const carsState = dispatch(setSearchCars(cars, data)).payload;
    dispatch(sortCarsArray(carsState, orderedBy));
  };
  return carCountInEachBrand
    .sort((a, b) => b[1] - a[1])
    .filter((el) => el[1] > 2)
    .map((el) => (
      <button
        className="b-brands__item"
        type="button"
        key={el[0]}
        onClick={() => {
          dispatch(setShowCars(false));
          setTimeout(() => {
            dispatch(setActivePage(0));
            setBrand(el[0]);
            scrollPageToTop();
          }, DELAY);
        }}
      >
        <img
          className="img-fluid popular-brands-img"
          src={`../../media/content/auto-logos/${el[0]
            .toLowerCase()
            .replace(' ', '')}.png`}
          alt={el[0]}
        />
      </button>
    ));
};
